import classNames from 'classnames'
import React from 'react'

const Dashboard: React.FC<{ active: boolean }> = ({ active }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="none" viewBox="0 0 27 27">
		<path
			className={classNames({
				'fill-brand-primary-md': active,
				'fill-[gray]': !active,
			})}
			fillRule="evenodd"
			d="M13.5 0L0 10.655V27h27V10.655L13.5 0zM2.453 24.577V11.864L13.5 3.147l11.045 8.717v12.713H2.454z"
			clipRule="evenodd"
		/>
	</svg>
)

export default Dashboard
